module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "term-page"
  }, [(this.term) ? _c('div', {
    staticClass: "term-content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.term.title))]), _c('p', [_vm._v(_vm._s(_vm.term.intro))]), _c('primary-button', {
    on: {
      "clicked": _vm.close
    }
  }, [_vm._v("Verder")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-772ea7e3","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Term.vue
// module id = B9bh
// module chunks = 0 1